module.exports = __webpack_public_path__ + "assets/img/header_icon_close.0295d768.svg";